/* Guarda Mundo - Home logo: flyer → slot (spec 0025 / ADR-024).
   Desktop: scroll amortecido (low-pass).
   Mobile: time-binary — ao sair do topo a fechadura sobe sozinha (tween),
   sem acompanhar scrollY (evita travar quando a URL bar some).
   Voo: always-fixed. Clamp gap título. Handoff sem duplicata.
   Tamanho: max = 1º paint (scale <= 1); nunca cresce no scroll. */

(() => {
  const ANIM_RANGE_VH = 0.7;
  const HANDOFF_P = 0.92;
  const SETTLE_MS = 800;
  const TITLE_EPS_PX = 0.3;
  const SMOOTH_TAU_MS = 120;
  const SMOOTH_EPS = 0.0005;
  const MAX_DT_MS = 64;
  const LOCK_GAP = 24;
  const FLYER_Z = '105';

  /* Mobile time-binary */
  const TOP_ON = 2;
  const TOP_OFF = 12;
  const TWEEN_MS = 850;

  const clamp01 = (v) => (v < 0 ? 0 : v > 1 ? 1 : v);
  const lerp = (a, b, t) => a + (b - a) * t;
  const easeInOutCubic = (x) =>
    x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2;
  const isMobile = () => window.matchMedia('(max-width: 749px)').matches;

  const init = () => {
    const logo = document.querySelector('[data-gm-home-logo]');
    const flyer = document.querySelector('[data-gm-home-lock-flyer]');
    const slot =
      document.querySelector('[data-gm-home-logo-slot]') ||
      logo?.querySelector('.gm-home-logo__hero');
    const heroTitle = document.querySelector('.gm-hero__slide-title');
    const titleWrap =
      heroTitle?.closest('.gm-hero__title-with-lock') || heroTitle;

    if (!logo) return;

    const markReady = () => {
      logo.setAttribute('data-gm-home-logo-ready', '');
      document.body.classList.add('gm-home-lock-ready');
    };

    const setDocked = (docked) => {
      if (docked) {
        logo.setAttribute('data-gm-lock-docked', '');
        document.body.classList.add('gm-home-lock-docked');
        flyer?.classList.add('is-docked');
      } else {
        logo.removeAttribute('data-gm-lock-docked');
        document.body.classList.remove('gm-home-lock-docked');
        flyer?.classList.remove('is-docked');
      }
    };

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion || !flyer || !slot || !heroTitle) {
      logo.style.setProperty('--gm-home-logo-progress', '1');
      setDocked(true);
      markReady();
      return;
    }

    if (!document.querySelector('.gm-hero')) {
      logo.style.setProperty('--gm-home-logo-progress', '1');
      setDocked(true);
      markReady();
      return;
    }

    const animRange = () =>
      Math.max(1, ANIM_RANGE_VH * (window.gmStableVh?.px() ?? window.innerHeight));
    const rawProgress = () => clamp01(window.scrollY / animRange());

    const flyerHome = flyer.parentElement;
    const flyerBefore = flyer.nextSibling;

    let natH = 0;
    let natW = 0;

    const clearFlightInline = () => {
      flyer.style.position = '';
      flyer.style.left = '';
      flyer.style.top = '';
      flyer.style.right = '';
      flyer.style.bottom = '';
      flyer.style.width = '';
      flyer.style.height = '';
      flyer.style.margin = '';
      flyer.style.translate = '';
      flyer.style.zIndex = '';
      flyer.style.transform = '';
      flyer.style.transformOrigin = '';
      flyer.style.opacity = '';
      flyer.style.visibility = '';
      flyer.style.color = '';
      flyer.classList.remove('is-flying');
    };

    const parkFlyerHome = () => {
      clearFlightInline();
      if (flyerHome && flyer.parentElement !== flyerHome) {
        flyerHome.insertBefore(flyer, flyerBefore);
      }
    };

    const ensureNatSize = () => {
      if (natH > 0) return;
      parkFlyerHome();
      const prevWrap = titleWrap?.style.transform ?? '';
      const prevTitle = heroTitle?.style.transform ?? '';
      if (titleWrap) titleWrap.style.transform = 'none';
      if (heroTitle && heroTitle !== titleWrap) heroTitle.style.transform = 'none';
      flyer.style.visibility = 'hidden';
      void flyer.offsetHeight;
      natH = flyer.offsetHeight || 140;
      natW = flyer.offsetWidth || natH * 0.45;
      flyer.style.visibility = '';
      if (titleWrap) titleWrap.style.transform = prevWrap;
      if (heroTitle && heroTitle !== titleWrap) {
        heroTitle.style.transform = prevTitle;
      }
    };

    const measureFrom = () => {
      ensureNatSize();
      const tr = titleWrap.getBoundingClientRect();
      return {
        left: tr.left + tr.width / 2 - natW / 2,
        top: tr.top - LOCK_GAP - natH,
        width: natW,
        height: natH,
      };
    };

    let rafId = null;
    let resizeRaf = null;
    let lastSettleT = 0;
    let prevTitleTop = null;
    let lastT = performance.now();
    let p = window.scrollY <= TOP_OFF ? 0 : 1;
    let flying = false;

    /* Mobile time-binary state */
    let atTop = window.scrollY <= TOP_OFF;
    let tween = null;
    /* From congelado no início do tween — imune a URL bar / sticky. */
    let frozenFrom = null;

    const startTween = (fromP, toP, now) => {
      tween = { from: fromP, to: toP, start: now, dur: TWEEN_MS };
      if (toP > fromP) {
        frozenFrom = measureFrom();
      } else {
        frozenFrom = null;
      }
    };

    const tickTween = (now) => {
      if (!tween) return;
      const u =
        tween.dur > 0 ? Math.min((now - tween.start) / tween.dur, 1) : 1;
      p = tween.from + (tween.to - tween.from) * easeInOutCubic(u);
      if (u >= 1) {
        p = tween.to;
        tween = null;
        if (p >= 1) frozenFrom = null;
      }
    };

    const stepMobile = (now) => {
      const y = window.scrollY;
      if (y <= TOP_ON) atTop = true;
      else if (y >= TOP_OFF) atTop = false;

      const target = atTop ? 0 : 1;
      if (!tween && p !== target) startTween(p, target, now);
      else if (tween && tween.to !== target) startTween(p, target, now);
      tickTween(now);
      p = clamp01(p);
    };

    const stepDesktop = (dt) => {
      const target = rawProgress();
      p += (target - p) * (1 - Math.exp(-dt / SMOOTH_TAU_MS));
      if (Math.abs(target - p) < SMOOTH_EPS) p = target;
      p = clamp01(p);
      frozenFrom = null;
    };

    const hideFlyerDocked = () => {
      flyer.classList.add('is-docked');
      flyer.style.opacity = '0';
      flyer.style.visibility = 'hidden';
      flyer.style.pointerEvents = 'none';
    };

    const render = (prog) => {
      logo.style.setProperty('--gm-home-logo-progress', prog.toFixed(4));

      if (prog < 0.001) {
        setDocked(false);
        flying = false;
        frozenFrom = null;
        parkFlyerHome();
        flyer.classList.remove('is-docked');
        flyer.style.color = '#ffffff';
        flyer.style.opacity = '1';
        flyer.style.visibility = 'visible';
        return;
      }

      if (prog >= HANDOFF_P) {
        hideFlyerDocked();
        setDocked(true);
        flying = false;
        parkFlyerHome();
        flyer.classList.add('is-docked');
        return;
      }

      setDocked(false);
      flyer.classList.remove('is-docked');

      const from =
        isMobile() && frozenFrom ? frozenFrom : measureFrom();
      const to = slot.getBoundingClientRect();
      if (from.height < 1 || to.height < 1) return;

      const titleTop = heroTitle.getBoundingClientRect().top;
      const fromCX = from.left + from.width / 2;
      const toCX = to.left + to.width / 2;
      const dx = (toCX - fromCX) * prog;

      const scaleP = clamp01(prog / HANDOFF_P);
      const scale = Math.min(1, lerp(1, to.height / from.height, scaleP));
      const scaledH = from.height * scale;

      let visualTop = from.top + (to.top - from.top) * prog;
      const maxFlyerTop = titleTop - LOCK_GAP - scaledH;
      /* No mobile com from congelado, não reclampa no título sticky (evita puxar de volta). */
      if (!(isMobile() && frozenFrom)) {
        visualTop = Math.min(visualTop, maxFlyerTop);
      }
      if (prog >= 0.75) {
        visualTop = Math.max(visualTop, to.top);
      }

      const dy = visualTop - from.top;
      const white = (1 - prog) * 100;

      if (flyer.parentElement !== document.body) {
        document.body.appendChild(flyer);
      }
      flying = true;
      flyer.classList.add('is-flying');
      flyer.style.position = 'fixed';
      flyer.style.left = `${from.left}px`;
      flyer.style.top = `${from.top}px`;
      flyer.style.width = `${from.width}px`;
      flyer.style.height = `${from.height}px`;
      flyer.style.right = 'auto';
      flyer.style.bottom = 'auto';
      flyer.style.margin = '0';
      flyer.style.translate = 'none';
      flyer.style.zIndex = FLYER_Z;
      flyer.style.transformOrigin = 'top center';
      flyer.style.transform = `translate(${dx.toFixed(2)}px, ${dy.toFixed(2)}px) scale(${scale.toFixed(4)})`;
      flyer.style.color = `color-mix(in srgb, #ffffff ${white.toFixed(2)}%, #3c3636)`;
      flyer.style.opacity = '1';
      flyer.style.visibility = 'visible';
    };

    const loop = (now) => {
      const dt = Math.min(now - lastT, MAX_DT_MS);
      lastT = now;

      if (isMobile()) stepMobile(now);
      else stepDesktop(dt);

      const titleTop = heroTitle.getBoundingClientRect().top;
      const titleMoving =
        prevTitleTop === null || Math.abs(titleTop - prevTitleTop) > TITLE_EPS_PX;
      prevTitleTop = titleTop;

      render(p);

      const settling = now - lastSettleT < SETTLE_MS;
      const tweening = Boolean(tween);
      const desktopSmoothing =
        !isMobile() && Math.abs(rawProgress() - p) >= SMOOTH_EPS;
      if (
        titleMoving ||
        settling ||
        tweening ||
        desktopSmoothing ||
        window.scrollY > 0 ||
        flying
      ) {
        rafId = window.requestAnimationFrame(loop);
      } else {
        rafId = null;
      }
    };

    const wake = () => {
      lastSettleT = performance.now();
      prevTitleTop = null;
      if (rafId == null) {
        lastT = performance.now();
        rafId = window.requestAnimationFrame(loop);
      }
    };

    let vhGen = window.gmStableVh?.gen() ?? 0;

    const remeasureNat = () => {
      natH = 0;
      natW = 0;
      frozenFrom = null;
      if (resizeRaf != null) return;
      resizeRaf = window.requestAnimationFrame(() => {
        resizeRaf = null;
        if (!isMobile()) p = rawProgress();
        render(p);
        wake();
      });
    };

    const onResize = () => {
      window.requestAnimationFrame(() => {
        const g = window.gmStableVh?.gen();
        if (g != null && g === vhGen) return;
        if (g != null) vhGen = g;
        remeasureNat();
      });
    };

    const onLogoResize = () => {
      remeasureNat();
    };

    const onVvChrome = () => {
      /* Mobile time-based: ignora chrome da URL bar (não mexe no tween). */
      if (isMobile() && (tween || p > 0.01)) return;
      wake();
    };

    markReady();
    ensureNatSize();
    render(p);
    wake();

    window.addEventListener('scroll', wake, { passive: true });
    window.addEventListener('resize', onResize, { passive: true });
    window.addEventListener('gm:vv-chrome', onVvChrome);

    if (typeof ResizeObserver !== 'undefined') {
      const ro = new ResizeObserver(onLogoResize);
      ro.observe(logo);
      ro.observe(slot);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
